import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { FetchHandlerModule } from 'nallian-shared-ui/lib/modules';
import communityTextService from '../services/communityText';
import { FETCH_SHAPE } from '../../app/lib/propTypeShapes';
import Markdown from '../../app/components/Markdown';

const CommunityText = ({ communityTextFetch, t }) => (
  <FetchHandlerModule fetches={[communityTextFetch]} handleLoading>
    {communityTextFetch.value ? (
      <Markdown markdown={communityTextFetch.value.contents} />
    ) : (
      <>{t('noCommunityData')}</>
    )}
  </FetchHandlerModule>
);

CommunityText.propTypes = {
  communityTextFetch: FETCH_SHAPE.isRequired,
  t: PropTypes.func.isRequired,
};

export default compose(communityTextService, withTranslation(['app', 'shared']))(CommunityText);
